var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.userid))]):_c('v-skeleton-loader',{attrs:{"type":"text","width":"100px"}})}
var staticRenderFns = []

export { render, staticRenderFns }